import React from "react";
import { Form, Modal, Row } from "react-bootstrap";
import Fontstyling from "../../../../components/common/comman";
import { useState } from "react";
import { useRef } from "react";
import { useEffect } from "react";
import * as Yup from "yup";
import { Formik } from "formik";
import {
  GetUWellnessProgramDetails,
  AddWellness,
  DeleteUWellnessProgram,
} from "../../../../api/User/ACG/UWellnessApi";
import DeleteModal from "../../../../components/common/Modal/DeleteModal";
import CustomMaterialTable from "../../../../components/common/CustomMaterialTable";
import CustomButton from "../../../../components/common/CustomButton";
import toastFile from "../../../../Service/ToastFile";
import CustomInputField from "../../../../components/common/CustomInputField";

const schema = Yup.object().shape({
  wellness_Program: Yup.string().required("Please enter Wellness Program"),
});

const UWellness = () => {
  const [data, setData] = useState([]);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [isGetData, setIsGetData] = useState(false);
  const [witchAction, setWitchAction] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const buttonRef = useRef(null);
  const column = [
    {
      title: "Wellness Program",
      field: "wellness_Program",
    },
  ];

  useEffect(() => {
    if (showModal === false) {
      setSelectedRowData(null);
    }
    if (isGetData) {
      getUWellnessProgramDetailsData();
    }
    setIsGetData(false);
  }, [showModal]);

  useEffect(() => {
    getUWellnessProgramDetailsData();
  }, []);

  const getUWellnessProgramDetailsData = () => {
    GetUWellnessProgramDetails()
      .then((res) => {
        if(res.status === 200 || res.status === 204){
        setData(res.data);
        }
      })
      .catch((err) => console.log({ err }));
  };

  const handleActions = (values) => {
    buttonRef.current.disabled = true;

    const { wellness_Program } = values;
    const payload = { id: 0, wellness_Program };

    if (witchAction === "add") {
      AddWellness(payload).then((res) => {
        if(res.status === 200 || res.status === 204){
        setIsGetData(true);
        toastFile("new");
        setShowModal(false);
        }
      });
    } else if (witchAction === "update") {
      AddWellness({
        ...payload,
        id: selectedRowData.id,
      }).then((res) => {
        if(res.status === 200 || res.status === 204){
        setIsGetData(true);
        toastFile("update");
        setShowModal(false);
        }
      });
    }
  };

  return (
    <div>
      <Modal
        show={showModal}
        aria-labelledby="contained-modal-title-vcenter"
        centered={witchAction !== "delete"}
      >
        <Modal.Header closeButton onHide={() => setShowModal(false)}>
          <Modal.Title
            id="contained-modal-title-vcenter"
            style={Fontstyling.modalHeading}
          >
            {witchAction === "add"
              ? "Add "
              : witchAction === "update"
              ? "Update "
              : "Delete "}
            Wellness Program
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {witchAction === "delete" ? (
            <DeleteModal
              onClickYes={() => {
                DeleteUWellnessProgram(selectedRowData?.id).then((res) => {
                  if(res.status === 200 || res.status === 204){
                  toastFile("delete");
                  setIsGetData(true);
                  setShowModal(false);
                  }
                });
              }}
              onClickNo={() => setShowModal(false)}
            />
          ) : (
            <Formik
              validationSchema={schema}
              onSubmit={handleActions}
              initialValues={{
                wellness_Program: selectedRowData?.wellness_Program,
              }}
            >
              {({
                handleSubmit,
                handleChange,
                handleBlur,
                values,
                touched,
                errors,
              }) => (
                <Form onSubmit={handleSubmit}>
                  {witchAction === "delete" ? (
                    <div className="text-wrap">
                      Are you sure that you want to delete the record?
                    </div>
                  ) : (
                    <>
                      <Row className="mb-2 gap-3">
                        <CustomInputField
                          label="Wellness Program"
                          name="wellness_Program"
                          value={values}
                          handleChange={handleChange}
                          handleBlur={handleBlur}
                          touched={touched}
                          errors={errors}
                          isRequired
                        />
                      </Row>
                    </>
                  )}
                  <div className="d-flex align-items-center justify-content-end gap-3 my-4">
                    <button
                      ref={buttonRef}
                      style={Fontstyling.savebutton}
                      type="submit"
                    >
                      save
                    </button>
                    <button
                      style={Fontstyling.cancelbutton}
                      type="reset"
                      onClick={() => setShowModal(false)}
                    >
                      Cancel
                    </button>
                  </div>
                  <span className="text-success" style={{fontSize:"12px"}}>
                    * No special characters are allowed
                  </span>
                </Form>
              )}
            </Formik>
          )}
        </Modal.Body>
      </Modal>
      <div className="text-end py-3 border-bottom">
        <CustomButton
          onClick={() => {
            setWitchAction("add");
            setShowModal(true);
          }}
        >
          Add Wellness Program
        </CustomButton>
      </div>
      <CustomMaterialTable
        column={column}
        data={data}
        selectedRow={selectedRow}
        setSelectedRow={setSelectedRow}
        setWitchAction={setWitchAction}
        setSelectedRowData={setSelectedRowData}
        setShowModal={setShowModal}
      />
    </div>
  );
};

export default UWellness;
